<template>
  <div class="info">
    <p v-if="data && data.total > 0">
      För tillfället får <strong>{{ data.total }}</strong> patienter sjukhusvård, varav <strong>{{ data.tehohoito }}</strong> vårdas på intensiven.
    </p>
    <p v-else>
      För tillfället vårdas inga coronapatienter på sjukhus.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HospitalInfo',
  components: {
  },
  props: {
    data: Object,
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
table {
  color: #000;
  text-align: left;
  // max-width: 400px;
  width: 100%;
  margin: 1em auto;
  line-height: 1;
  border-collapse: collapse;

  caption {
    font-weight: bold;
    text-align: center;
    margin-bottom: 4px;
    margin-top: 4px;
  }

  th {
    font-weight: bold;
    text-align: right;
    background-color: #fff !important;
    color: #000 !important;
    text-transform: none !important;
  }

  td, th {
    padding: 10px;
    border: none;
    border-bottom: 2px solid #dedede;

    &.number {
      text-align: right;
    }
  }
}
</style>
